module.exports = __webpack_public_path__ + "static/media/01_escala-burnaby.aa558dc9.jpg";